import * as React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import { PageContent } from '../../../../components/page-components/PageContent';
import { PageNames, Routes } from '../../../../utils/app-constants';
import '../../../../transportation/styles.scss';
import { ImportStopFileScene } from './ImportStopFile';
import { RoutingDeliveriesScene } from './RoutingDeliveries';
import { RoutingOrderListScene } from './RoutingOrderList';

export const RoutingScene = (props: IBaseSceneProps) => {

    return <PageContent pageName={PageNames.TRANSPORTATION_PLANNING}>
            <Switch>

                { /* Deliveries */ }
                <Route
                    key="transportation-planning-deliveries"
                    exact={true}
                    path={ Routes.ROUTING_ROUTING_DELIVERIES }
                    render={() => <RoutingDeliveriesScene />}
                />

                { /* Import */ }
                <Route
                    key="transportation-planning-import"
                    exact={true}
                    path={ Routes.ROUTING_ROUTING_IMPORT }
                    render={() => <ImportStopFileScene />}
                />

                {/* Grouping Pages  */}
                <Route
                    key="transportation-planning-delivery-orders"
                    exact={true}
                    path={`${ Routes.ROUTING_ROUTING_DELIVERIES }/:dealerId/:addressId/:date?`}
                    render={() => 
                        <RoutingOrderListScene
                            location={ props.location }
                            match={ props.match }
                        />
                    }
                />   

                { /* There used to be a pickups tab, so send old links to the deliveries */ }
                <Redirect
                    key="transportation-planning-pickups-redirect"
                    exact={true}
                    from={ Routes.ROUTING_ROUTING_PICKUPS }
                    to={ Routes.ROUTING_ROUTING_DELIVERIES } />

                <Redirect
                    key="transportation-planning-redirect"
                    exact={true}
                    from={ Routes.ROUTING_ROUTING }
                    to={ Routes.ROUTING_ROUTING_DELIVERIES } />

            </Switch>
            
        </PageContent>;
    
};
